var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options;  
__p+='\n\n<li id="property-tax-section" class="link-tertiary">\n  <i class="ra ra-circle legend-tax icon-space-right"></i> Property Tax\n  <a rel="popover" href="javascript:void(0)" data-placement="bottom" class="veteran-popover-toggle popover-property-tax" data-popover-content="#property-tax-info"><i class="ra-info-circle icon-info-circle-bg ra"></i></a>\n  <div class="float-right editinplace-trigger display-inline">\n    <input type="text" data-rate="'+
((__t=( mortgageData.property_tax_rate ))==null?'':__t)+
'" value="'+
((__t=( mortgageData.property_tax ))==null?'':__t)+
'" class="input-no-style input-edit-inplace payment_option_fields" id="property_tax" maxlength="8" size="8"/>\n  </div>\n  <!-- property taxe popover -->\n  <div id="property-tax-info" class="hide payment-tax-info-popover">\n    <div class="font-size-base">\n      '+
((__t=( mortgageData.disclaimer ))==null?'':__t)+
'\n    </div>\n  </div>\n</li>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/legend/tertiary.jst.ejs